import {
  SitesAccessLogs200,
  SitesErrorLogs200,
} from '@newfold/huapi-js/src/index.schemas';

type ErrorLogsInfoType = {
  [key: number]: SitesErrorLogs200;
};
export const errorLogsInfo: ErrorLogsInfoType = {
  200: {
    datetime_end: '2024-02-10 03:08:51',
    datetime_start: '2024-01-31 03:08:51',
    page_id:
      'search_after:WzE3MTM4MTk4MDY2ODMsIjJkMzE2YmYzM2Y3MDA4Y2MyZTYzZTcxMWE5OGM3ZThmIl0=',
    total: 45,
    logs: [
      {
        file: '/wordpress/mu-plugins/sso.php',
        kind: 'mu-plugins',
        line: 56,
        message: 'PHP Fatal error:  Cannot redeclare sso_check() <..snipped..>',
        name: 'sso.php',
        severity: 'Fatal error',
        datetime: '2024-02-07T09:06:06.000Z',
        epoch: 1713509693,
      },
      {
        file: '/wordpress/abc-plugins/sso.php',
        kind: 'abc-plugins',
        line: 58,
        message: 'Some warning:  testing warning',
        name: 'sso.php',
        severity: 'Warning',
        datetime: '2024-02-09T08:07:07.000Z',
        epoch: 1713509694,
      },
    ],
  },
  201: {
    datetime_end: '2024-02-10 03:08:51',
    datetime_start: '2024-01-31 03:08:51',
    page_id: '',
    total: 0,
    logs: [],
  },
};

type AccessLogsInfoType = {
  [key: number]: SitesAccessLogs200;
};
export const accessLogsInfo: AccessLogsInfoType = {
  200: {
    datetime_end: '2024-02-10 03:08:51',
    datetime_start: '2024-01-31 03:08:51',
    page_id:
      'search_after:WzE3MTM4MTk4MDY2ODMsIjJkMzE2YmYzM2Y3MDA4Y2MyZTYzZTcxMWE5OGM3ZThmIl0=',
    total: 920,
    logs: [
      {
        body_bytes_sent: 0,
        // @ts-expect-error Check huapi schema
        cached: false,
        datetime: '2024-04-19T06:54:53.805Z',
        http_host: 'example.com',
        http_referrer: '-',
        http_user_agent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.3',
        http_x_forwarded_for: '138.68.130.46',
        renderer: 'php',
        request_completion: 'OK',
        request_time: 0.15,
        request_type: 'GET',
        request_url: '/wp-admin/admin-ajax.php',
        scheme: 'https',
        status: 200,
        epoch: 1713509695,
        type: 'nginx_json',
        user_ip: '1.3.3.7',
      },
    ],
  },
  201: {
    datetime_end: '2024-02-10 03:08:51',
    datetime_start: '2024-01-31 03:08:51',
    page_id: '',
    total: 0,
    logs: [],
  },
};
